export default __webpack_public_path__ + "static/media/dummy-profile-img.c035a621.jpg";